export const textInputProps = {
    rounded: true,
    filled: true,
    dense: true,
    'background-color': 'primary',
    color: 'secondary',
}
